import { useRuntimeConfig } from 'nuxt/app'

export function useAttainConfig() {
  return useRuntimeConfig().public.attain
}
